import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { RequireSession } from './RequireSession';
import { Login } from './pages/Login';
import { Home } from './pages/Home';
import { Goto } from './pages/Goto';
import { RefreshToken } from './pages/RefreshToken';
import { RefreshTokenSuccess } from './pages/RefreshTokenSuccess';
import { Logout } from './pages/Logout';
import { AdminPage } from './Admin';

// Same routes as the SuperTokens login page (hello2.songtek.net); the apps link to /auth, /Goto, /RefreshToken and /Logout.
export const App: React.FC = () => (
    <BrowserRouter>
        <Routes>
            <Route path="/auth" element={<Login />} />
            <Route path="/" element={<RequireSession><Home /></RequireSession>} />
            <Route path="/Logout" element={<Logout />} />
            <Route path="/Goto/:url" element={<RequireSession><Goto /></RequireSession>} />
            <Route path="/RefreshToken" element={<RefreshToken />} />
            <Route path="/RefreshTokenSuccess" element={<RequireSession><RefreshTokenSuccess /></RequireSession>} />
            <Route path="/admin/*" element={<RequireSession><AdminPage /></RequireSession>} />
        </Routes>
    </BrowserRouter>
);
